import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';


registerFragment('cbdce-heading', (fragmentElement, configuration, meta) => {

});

if (import.meta.hot) {
    import.meta.hot.accept();
}
